export const DnDTypes = {
    TASK: 'task',
    ASSET: 'asset',
    RESOURCE: 'resource',
    CONTRACTOR: 'contractor',
    MEMBER: 'member',
};
